import { ActivityIndicator, Image,Platform, View } from 'react-native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import ManageLimitIcon from '../../assets/Icons/ManageLimitIcon';
import TransactionIcon from '../../assets/Icons/TransactionIcon';
import HomeIcon from '../../assets/Icons/HomeIcon';
import TransactionScreen from '../screens/Transactions/Transactions';
import DashboardScreen from '../screens/Dashboard/Dashboard';
import EnterEmail from '../screens/EnterEmail/EnterEmail';
import VerifyEmail from '../screens/VerifyEmail/VerifyEmail';
import Faqs from '../screens/Faqs/Faq';
import ROUTE from './routes';
import VerifyPan from '../screens/VerifyPan/VerifyPan';
import InterestCalculator from '../screens/InterestCalculator/InterestCalculator';
import { BottomTabParamList, PrivateStackParamList } from './types';
import ManageLimit from '@screens/ManageLimit/ManageLimit';
import UserProfile from '../screens/UserProfile/UserProfile';
import AboutUs from '../screens/AboutUs/AboutUs';
import WebviewScreen from '../screens/Webview/WebviewScreen';
import LendingPartners from '../screens/UserProfile/LendingPartners';
import ProductDetails from '../screens/UserProfile/ProductDetails';
import ContactUs from '../screens/UserProfile/ContactUs';
import { useAppSelector } from '../store/hooks';
import Loader from '../screens/Loader/Loader';
import { useEffect, useState } from 'react';
import { useNavigation } from '@react-navigation/native';
import { checkColor } from '@app/utils';
import { themeColorSet } from '@app/theme';

const Stack = createNativeStackNavigator<PrivateStackParamList>();
const Tab = createBottomTabNavigator<BottomTabParamList>();

function MyTabs({navigation}) {
  const userDetails = useAppSelector((state) => state.auth.userDetails);
  const { showVoltBottomNavBar, showManageLimit, showTransactionHistory, showHome } = useAppSelector((state) => state.platformParams);
  const showBottomBar = showVoltBottomNavBar && ([showManageLimit , showTransactionHistory , showHome].filter(Boolean).length >= 2);
  const [isLoading , setIsLoading] = useState(Platform.OS !== 'web')  
  useEffect(() => {
    const creditId = userDetails?.linkedCredits[0]?.creditId || null; // check if creditId is present then navigate to splash screen for LMS flow
    const currentStepName = userDetails?.linkedApplications[0]?.currentStepId as keyof typeof ROUTE | undefined;
    if (creditId !== null || currentStepName === null) {
      console.log('MyTabs REDIRECTION')
      navigation.navigate("SPLASHSCREEN")
    }
    setTimeout(() => {
      setIsLoading(false)
    }, 1000)
  }, [userDetails])
  
  if (isLoading) {
    return (
      <View style={{ flex: 1, backgroundColor: "white", alignItems: 'center', justifyContent: 'center'  }}>
        <ActivityIndicator size={32} color={checkColor("#1434CB")} />
      </View>
    )
  }

  return (
    <Tab.Navigator
      screenOptions={{
        headerShown: false,
        tabBarLabelStyle: {fontSize : 12 , fontFamily : "Inter" },
        tabBarStyle:{backgroundColor : themeColorSet['bg-fill-primary'],borderTopColor : themeColorSet['border-secondary'],borderTopWidth : 1,
          paddingBottom: 12,
          paddingTop: 12,
          height: 64,
          display: showBottomBar ? 'flex' :'none',
        },
        tabBarActiveTintColor: themeColorSet['text-action-primary'],
        tabBarInactiveTintColor: '#667085',
        title: 'Volt - Unlock cash from your mutual funds saving',
      }}
    >
     <Tab.Screen
        options={{
          tabBarLabel: 'Home',
          tabBarLabelPosition:'below-icon',
          tabBarIcon: ({ focused }) => (
            <HomeIcon color={focused ? themeColorSet['text-action-primary'] : '#667085'} />
          ),
        }}
        name={ROUTE.DASHBOARD_SCREEN}
        component={DashboardScreen}
      />
     {showTransactionHistory && <Tab.Screen
        options={{
          tabBarLabel: 'Transactions',
          tabBarLabelPosition:'below-icon',
          tabBarIcon: ({ focused }) => (
            <TransactionIcon color1={focused ? themeColorSet['text-action-primary'] : '#667085'} color2={focused ? '#1434cc66' : '#E4E7EC'} />
          ),
        }}
        name={ROUTE.TRANSACTION_SCREEN}
        component={TransactionScreen}
      />}
      {showManageLimit && <Tab.Screen
        options={{
          tabBarLabel: 'Manage Limit',
          tabBarLabelPosition:'below-icon',
          tabBarIcon: ({ focused }) => (
            <ManageLimitIcon color2={focused ? '#1434cc66' :'#667085'} color1={focused ? themeColorSet['text-action-primary'] :  '#E4E7EC'} />
          ),
        }}
        name={ROUTE.MANAGE_LIMIT_SCREEN}
        component={ManageLimit}
      />}
    </Tab.Navigator>
  );
}


const PrivateRoutes = ({ userDetails }) => {
  const currentStepName = userDetails?.linkedApplications[0]?.currentStepId as keyof typeof ROUTE | undefined;
  const userEmailNotExist = userDetails?.linkedBorrowerAccounts[0]?.accountHolderEmail===null;
  const platformParams = useAppSelector((state) => state.platformParams);

  const navigation = useNavigation()
  const {showHome} = platformParams
  useEffect(() => {
    if (Platform.OS !== 'web') {
      // BootSplash.hide({ fade: true })
    }
  }, [])

  useEffect(() => {
    const creditId = userDetails?.linkedCredits[0]?.creditId || null; // check if creditId is present then navigate to splash screen for LMS flow
    const currentStepName = userDetails?.linkedApplications[0]?.currentStepId as keyof typeof ROUTE | undefined;
    if(creditId!==null || currentStepName === null){
      navigation.navigate("SPLASHSCREEN")
      return;
    }
  }, [userDetails])

  
  return (
    <Stack.Navigator
      screenOptions={{
        title: 'Volt - Unlock cash from your mutual funds saving',
        // animation: 'slide_from_right', // iOS-like horizontal slide animation
        // gestureEnabled: true,         // Enable swipe gestures
        // gestureDirection: 'horizontal', // Direction of the swipe gesture
      }}
      initialRouteName={Platform.OS === 'web' ? ROUTE.LOADING  : ROUTE.HOME}
      >
      {Platform.OS === 'web' && <Stack.Screen
        name={ROUTE.LOADING}
        component={Loader}
        options={{ headerShown: false }}
      />}
      {showHome && <Stack.Screen
        name="HOME"
        component={MyTabs}
        options={{ headerShown: false }}
      />}
      {userEmailNotExist && <Stack.Screen
        name={ROUTE.VERIFY_EMAIL}
        component={VerifyEmail}
        options={{ headerShown: false }}
      />}
      {userEmailNotExist && <Stack.Screen
        name={ROUTE.ENTER_EMAIL}
        component={EnterEmail}
        options={{ headerShown: false }}
      />}
      {ROUTE.KYC_PAN_VERIFICATION===currentStepName && <Stack.Screen
        name={ROUTE.KYC_PAN_VERIFICATION}
        component={VerifyPan}
        options={{ headerShown: false }}
      />}
      <Stack.Screen
        name={ROUTE.USER_PROFILE}
        component={UserProfile}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.ABOUT_US}
        component={AboutUs}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.WEBVIEW_SCREEN}
        component={WebviewScreen}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.LENDING_PARTNERS}
        component={LendingPartners}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.PRODUCT_DETAILS}
        component={ProductDetails}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.CONTACT_US}
        component={ContactUs}
        options={{ headerShown: false }}
      />
         <Stack.Screen
        name={ROUTE.FAQ}
        component={Faqs}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.INTEREST_CALCULATOR}
        component={InterestCalculator}
        options={{ headerShown: false }}
      />
    </Stack.Navigator>
  );
};

export default PrivateRoutes;
